<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">My Tickets</span>
		</div>

		<div class="page-subtitle-container flxRow-between hSpace4">
			<span class="page-subtitle f-1-0">Track your support requests</span>

			<div class="flxRow hSpace1" style="align-items: center;"
				 tooltip="View all support tickets submitted by users in your plan"
				 *ngIf="gs.userInfo?.user_role === dic.CONSTANTS.userRole.admin || gs.userInfo?.user_role === dic.CONSTANTS.userRole.subAdmin">
				<toggle-switch-c id="viewAllPlans"
								 [(model)]="viewAllPlanUsers"
								 [hideText]="true"
								 [isDisabled]="!allTickets"
								 (onChange)="getTickets()"></toggle-switch-c>
				<label for="viewAllPlans">View All Users Tickets</label>
			</div>
		</div>
	</div>

	<div class="page-inner-content-holder no-scroll flxClmn">
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5; background: white;"
			#ticketsTable
			[list]="allTickets"
			[headers]="_.compact([
					{text: 'Created', sortKey: 'created_at', width: '130px'},
					{text: 'Updated', sortKey: 'updated_at', width: '130px'},
					viewAllPlanUsers && {text: 'Submitted By', sortKey: 'custom_fields.cf_requester_email'},
					{text: 'Ticket ID', sortKey: 'id', width: '100px'},
					{text: 'Title', sortKey: 'subject'},
					{text: 'Description'},
					{text: 'Type', sortKey: 'type', width: '110px'},
					{text: 'Status', sortKey: 'status', width: '100px'},
				])"
			[cellsPrototype]="_.compact([
					{textKey: 'created_at', textType: 'dateAndTime'},
					{textKey: 'updated_at', textType: 'dateAndTime'},
					viewAllPlanUsers && {textKey: 'custom_fields.cf_requester_email'},
					{textKey: 'id'},
					{textKey: 'subject'},
					{textKey: 'description_text'},
					{textKey: 'type'},
					{html: 'statusCell'}
				])"
			[cellActions]="{
					enable: true,
					selectItemActionCb:	selectTicketAction,
					initActionsFunction: showTicketActions,
					showInRed: {enable: true, terms: ['Delete']}
				}"
			[bulkActions]="{
					enable: !viewAllPlanUsers,
					selectBulkActionCb:	selectTicketBulkAction,
					initBulkActionsFunction: showTicketBulkActions,
					showInRed: {enable: true, terms: ['Delete']}
				}"
			[filterData]="filterData"
			(searchFunction)="searchTicket($event)"
			(onAnyItemSelected)="!$event.isItemSelectCheckboxClicked && getTicketData($event.item); ticketsTable.filterSelectedItems();"
			[options]="{
					loadingTableFlag: getTicketsInProcess,
					refreshFunction: getTickets,
					itemsNameSingular: 'ticket',
					defaultSortKey: '-updated_at'
				}"
		>
			<!--log action cells-->
			<ng-template #customCells let-item let-cellId="cellId">
				<span *ngIf="cellId === 'statusCell'">
					{{item.status === 6 ? 'Waiting for Customer' : item.status}}
				</span>
			</ng-template>

			<div tableButtons>
				<btn-c endIcon="far fa-plus"
					   (action)="openTicketPopup();">
					Open a Ticket
				</btn-c>
			</div>
			<!---->
		</trustifi-table-c>
	</div>

    <popup-c *ngIf="newTicketPopup?.show"
			 [ngClass]="{'no-content-padding' : newTicketPopup.showAI}"
             [head]="newTicketPopup.showAI ? 'How can we help?' : 'Open a Support Ticket'" size="medium" height="750px"
             (confirmCb)="openTicketExecute();"
			 (closeCb)="newTicketPopup = null;"
             [buttons]="!newTicketPopup.showAI ? {cancel: 'Cancel', confirm: {text: 'Send', loading: newTicketPopup.inProcess}} : null">
        <div class="flxClmn f-1-0 gap-3" style="overflow: auto;">
			<!--AI chat-->
			<div class="flxClmn f-1-0 gap-3 overflow-auto animated fadeIn" [hidden]="!newTicketPopup.showAI">
				<ai-assistant-chat #chatBotEl class="flex-column f-1-0" style="min-height: 0;"
								   [isHeadless]="true">
				</ai-assistant-chat>
				<!-- CC: "Was this helpful?" banner after AI responds -->
				<div class="flex-column centralize overflow-hidden animated fadeIn" style="transition: all 0.4s 1.2s ease-out; border-top: 1px solid #e9ecef;"
					 [ngStyle]="{'max-height' : chatBotEl.conversation?.length > 2  ? '80px' : '0', 'padding' : chatBotEl.conversation?.length > 2 ? '12px' : '0'}">
					<span class="mb-2 fw-500" style="font-size: 0.9rem;">Was this helpful?</span>
					<div class="flex-row gap-2">
						<btn-c style="width: 130px;"
							   endIcon="far fa-check"
							   [loading]="newTicketPopup.aiHelpedLoader"
							   [isDisabled]="newTicketPopup.aiHelpedLoader === false"
							   (action)="resolvedByAI();">
							Yes, thanks!
						</btn-c>
						<btn-c style="width: 130px;"
							   endIcon="far fa-headset" variant="outlined"
							   (action)="escalateToTicket(chatBotEl);">
							No, open ticket
						</btn-c>
					</div>
				</div>
			</div>
            <!--contact form-->
            <div class="f-1-0 flxClmn gap-3 animated fadeIn" *ngIf="!newTicketPopup.showAI">
				<!-- CC: back to AI chat option + pre-fill note -->
				<div class="flex-column gap-1" *ngIf="newTicketPopup.aiConversation && chatBotEl.conversation?.length > 1">
					<btn-c class="popup-action-btn" variant="text"
						   startIcon="far fa-arrow-left"
						   (action)="newTicketPopup.showAI = true;">
						Back to chat
					</btn-c>
					<hr class="mb-0 opacity-25" />
				</div>
				<span>Fill out the form, and we will reply as soon as possible!</span>
                <div style="flex: 1 0;">
                    <table class="simpleDataTableShrink middle w100 h100" style="table-layout: fixed;">
                        <tr>
							<td style="height: 35px; width: 135px; white-space: nowrap; padding-right: 1vw;">
                                Issue type
                            </td>
                            <td>
                                <app-dropdown-c style="width:100%;" [text]="newTicketPopup.reasonSelected || 'Select from list'">
                                    <ul style="overflow: auto; max-height: 180px;">
                                        <li *ngFor="let option of newTicketPopup.reason"
                                            (click)="newTicketPopup.reasonSelected = option"
                                            id="{{option}}">
                                            {{option}}
                                        </li>
                                    </ul>
                                </app-dropdown-c>
                            </td>
                        </tr>
                        <tr>
							<td style="height: 30px; white-space: nowrap;">
								Severity level
							</td>
							<td>
								<app-dropdown-c style="width:100%;" [text]="newTicketPopup.severitySelected.split(' (')[0] || 'Select from list'">
									<ul style="overflow: auto; max-height: 180px;">
										<li *ngFor="let option of newTicketPopup.severityLevels"
											(click)="newTicketPopup.severitySelected = option"
											id="{{option.split(' (')[0]}}">
											{{option.split(' (')[0]}}
										</li>
									</ul>
								</app-dropdown-c>
							</td>
						</tr>
                        <tr>
                            <td style="height: 35px; white-space: nowrap;">
                                Title
                            </td>
                            <td>
                                <input type="text" style="margin: 0 0 5px 0; height: 35px; width: 100%;"
                                       placeholder="Summarize your issue"
									   [ngClass]="{'validation-error' : newTicketPopup.supportTicketTitleTextErr}"
                                       [autofocus]="true"
									   (keyup)="newTicketPopup.supportTicketTitleTextErr = false;"
                                       [(ngModel)]="newTicketPopup.messageTitle">
                            </td>
                        </tr>
						<tr>
							<td style="height: 35px; white-space: nowrap;">
								Cc (optional)
							</td>
							<td>
								<input type="text" style="margin: 0 0 5px 0; height: 35px; width: 100%;"
									   placeholder="Up to 2 colleagues from your organization, separated by commas"
									   [ngClass]="{'validation-error' : newTicketPopup.ccInputError}"
									   (keyup)="newTicketPopup.ccInputError = false;"
									   [(ngModel)]="newTicketPopup.ccInput">
							</td>
						</tr>
                        <tr>
                            <td style="vertical-align: top;">
                                Description
                            </td>
                            <td>
                                <textarea class="color-equalized" style="width: 100%; height:100%; min-height: 150px; resize: none;"
										  [ngClass]="{'validation-error' : newTicketPopup.supportTicketTextErr}"
										  (keyup)="newTicketPopup.supportTicketTextErr = false;"
										  placeholder="Describe your issue"
										  [(ngModel)]="newTicketPopup.messageText"></textarea>
							</td>
						</tr>
						<tr>
							<td style="vertical-align: top;">
								Attach files
							</td>
							<td class="bs-enabled">
								<div class="w-100 cursor-pointer flex-column overflow-auto" style="height: 100px; border: solid 1px #cccccc; border-radius: 4px;"
									 [(files)]="attachmentFiles"
									 ngfDrop
									 ngfSelect
									 multiple="1"
									 accept=".pdf,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.bmp,.webp,.zip,.eml,.msg,.docx,.doc,.htm,.html"
									 (filesChange)="validateFiles(attachmentFiles);"
									 [(validDrag)]="validDrag"
									 [(invalidDrag)]="invalidDrag"
									 [ngClass]="{'drag-and-drop-hover': validDrag, 'dragOverClassObj': validDrag}">
									<div class="flex-column centralize p-4 gap-2 text-muted hvr-darken f-1-0" *ngIf="!attachmentFiles?.length">
										<i class="far fa-paperclip" style="font-size: 1.5rem;"></i>
										<span class="fw-500">Drag and drop here or click to select files</span>
									</div>
									<ng-container *ngIf="attachmentFiles?.length">
										<div class="flex-column centralize gap-2 f-1-0 p-2">
											<div class="flex-row gap-2 align-items-center w-100" *ngFor="let attachment of attachmentFiles">
												<img style="width: 23px;" [src]="gs.getFileIcon(attachment.name)">
												<span class="fw-500 fst-italic text-success ellipsis f-1-0">{{attachment.name}}</span>
												<span class="text-muted flex-shrink-0" style="font-size: 12px;" *ngIf="attachment.size">{{attachment.size | FormatBytes:0}}</span>
												<i class="zmdi zmdi-close px-2 py-1 text-danger hvr-opacity" tooltip="Remove" (click)="$event.stopPropagation(); removeFromAttachments(attachmentFiles, attachment)"></i>
											</div>
										</div>
									</ng-container>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</popup-c>

	<popup-c *ngIf="showTicketDetailsPopup?.show"
			 head="Ticket Conversation" size="large"
			 (closeCb)="showTicketDetailsPopup = false;">
		<div class="flxClmn f-1-0 vSpace2" style="position: relative; min-height: 200px;">
			<!-- Centered loader -->
			<div *ngIf="showTicketDetailsPopup.inProcess"
				 style="position: absolute; inset: 0; display: flex; justify-content: center; align-items: center; z-index: 10;">
				<loader class="opacity-75"></loader>
			</div>

            <!-- Main content -->
			<div class="f-1-0 flxClmn" *ngIf="!showTicketDetailsPopup.inProcess">
				<ng-container *ngIf="!viewAllPlanUsers">
					<div class="flex-row gap-4">
						<span class="fw-bold">Add a reply</span>

						<div class="flex-column gap-1 f-1-0" style="z-index: 9999; max-width: 485px;">
							<div class="flex-column gap-1 bg-light p-2">
								<div class="flex-row gap-2">
									<span class="fw-bold">To:</span>
									<span>{{gs.corpname}}'s Support ({{supportEmail}})</span>
								</div>
								<div class="flex-row gap-2" *ngIf="showTicketDetailsPopup.ticketObj.cc_emails?.length">
									<span class="fw-bold">Cc:</span>
									<span>{{showTicketDetailsPopup.ticketObj.cc_emails.join(', ')}}</span>
								</div>
							</div>
							<div id="summernoteContainer"
								 (dragenter)="toggleSummernoteDragState(true, $event)"
								 (dragleave)="toggleSummernoteDragState(false, $event)"
								 (dragend)="toggleSummernoteDragState(false, $event)">
								<div class="summernote-editor" id="summernote"
									 style="overflow: auto; box-sizing: border-box; border: 1px solid #ccc; vertical-align: top; resize: none;"
									 [ngxSummernote]="summernoteConfig"
									 [(ngModel)]="showTicketDetailsPopup.text">
								</div>
							</div>
							<div class="w-100 cursor-pointer flex-column overflow-auto bg-light" style="min-height: 40px; max-height: 100px; border: solid 1px #cccccc; border-radius: 4px;"
								 [(files)]="showTicketDetailsPopup.attachmentFiles"
								 ngfDrop
								 ngfSelect
								 multiple="1"
								 accept=".pdf,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.bmp,.webp,.zip,.eml,.msg,.docx,.doc,.htm,.html"
								 (filesChange)="validateFiles(showTicketDetailsPopup.attachmentFiles);"
								 [(validDrag)]="validDrag"
								 [(invalidDrag)]="invalidDrag"
								 [ngClass]="{'drag-and-drop-hover': validDrag, 'dragOverClassObj': validDrag}">
								<div class="flex-row p-2 centralize gap-2 f-1-0" *ngIf="!showTicketDetailsPopup.attachmentFiles?.length">
									<div class="flex-row gap-2 align-items-center">
										<i class="far fa-paperclip"></i>
										<span class="fw-500">Attach files</span>
									</div>
									<span>(Drag and drop here or click to select files)</span>
								</div>
								<ng-container *ngIf="showTicketDetailsPopup.attachmentFiles?.length">
									<div class="flex-column centralize gap-2 f-1-0 p-2">
										<div class="flex-row gap-2 align-items-center w-100" *ngFor="let attachment of showTicketDetailsPopup.attachmentFiles">
											<img style="width: 23px;" [src]="gs.getFileIcon(attachment.name)">
											<span class="fw-500 fst-italic text-success ellipsis f-1-0">{{attachment.name}}</span>
											<span class="text-muted flex-shrink-0" style="font-size: 12px;" *ngIf="attachment.size">{{attachment.size | FormatBytes:0}}</span>
											<i class="zmdi zmdi-close px-2 py-1 text-danger hvr-opacity" tooltip="Remove" (click)="$event.stopPropagation(); removeFromAttachments(showTicketDetailsPopup.attachmentFiles, attachment)"></i>
										</div>
									</div>
								</ng-container>
							</div>
						</div>

						<btn-c class="align-self-start"
							   endIcon="far fa-paper-plane"
							   [loading]="showTicketDetailsPopup.replyInProcess"
							   [isDisabled]="!showTicketDetailsPopup.text"
							   (action)="addUserReply(showTicketDetailsPopup.ticketObj)">
							Send
						</btn-c>
					</div>
				</ng-container>

				<ng-container *ngIf="viewAllPlanUsers">
					<div class="flex-column border gap-1 bg-light p-2 px-3">
						<span class="fw-bold mb-1" style="font-size: 1rem;">
							Ticket Details
						</span>
						<div class="flex-row gap-2" *ngIf="showTicketDetailsPopup.ticketObj.custom_fields?.cf_requester_email">
							<span class="fw-bold">From:</span>
							<span>{{showTicketDetailsPopup.ticketObj.custom_fields.cf_requester_email}}</span>
						</div>
						<div class="flex-row gap-2">
							<span class="fw-bold">To:</span>
							<span>{{gs.corpname}}'s Support ({{supportEmail}})</span>
						</div>
						<div class="flex-row gap-2" *ngIf="showTicketDetailsPopup.ticketObj.cc_emails?.length">
							<span class="fw-bold">Cc:</span>
							<span>{{showTicketDetailsPopup.ticketObj.cc_emails.join(', ')}}</span>
						</div>
					</div>
				</ng-container>

				<br/>
				<hr/>

				<div class="flex-column gap-3 mb-2">
					<div class="flex-column gap-2" *ngFor="let message of showTicketDetailsPopup.info.conversations | orderBy: '-created_at'; let last = last;">
						<div class="flex-row justify-content-between">
							<ng-container *ngIf="message.support_email === supportEmail">
								<span class="fw-bold" *ngIf="message.category === 3">
									{{message.from_email || '"' + gs.corpname + ' Support" <' + supportEmail + '>'}}
								</span>
								<span class="fw-bold" *ngIf="message.category !== 3">
									{{gs.userInfo.name && gs.userInfo.name !== gs.userInfo.email ? '"' + gs.userInfo.name + '" <' +  gs.userInfo.email + '>' : gs.userInfo.email || ''}}
								</span>
							</ng-container>
							<ng-container *ngIf="!message.support_email">
								<span class="fw-bold" *ngIf="message.category === 3">
									{{message.from_email || '"' + gs.corpname + ' Support" <' + supportEmail + '>'}}
								</span>
								<span class="fw-bold" *ngIf="message.category !== 3">
									{{gs.userInfo.name && gs.userInfo.name !== gs.userInfo.email ? '"' + gs.userInfo.name + '" <' +  gs.userInfo.email + '>' : gs.userInfo.email || ''}}
								</span>
							</ng-container>
							<span *ngIf="message.support_email && message.support_email !== supportEmail" class="fw-bold">
								{{message.from_email}}
							</span>
							<span style="color: gray;">{{message.created_at | date:'short'}}</span>
						</div>
						<div class="bg-light p-3" *ngIf="message.source !== 6" [innerHTML]="sanitizer.bypassSecurityTrustHtml(message.description || message.body)"></div>
						<div class="bg-light flex-column gap-2 p-3" *ngIf="message.source === 6">
							<span style="font-size: 13px;">
							  <b><u>New Survey Feedback</u></b>
							  <span *ngIf="showTicketDetailsPopup.info.status === 5">
								(Ticket closed
								<span *ngIf="showTicketDetailsPopup.info.custom_fields?.cf_closure_reason">
								  | Closure reason: {{ showTicketDetailsPopup.info.custom_fields.cf_closure_reason }}
								</span>)
							  </span>
							</span>
							<span class="mt-1">Satisfaction Rating:
							  <ng-container [ngSwitch]="message.satisfaction_rating">
							    <i *ngSwitchCase="103" class="far fa-smile text-success" tooltip="Happy"></i>
							    <i *ngSwitchCase="100" class="far fa-meh text-warning" tooltip="Neutral"></i>
							    <i *ngSwitchCase="-103" class="far fa-frown text-danger" tooltip="Unhappy"></i>
							    <span *ngSwitchDefault>Not rated</span>
							  </ng-container>
							</span>
							<span *ngIf="message.body_text">Feedback: {{message.body_text}}</span>
						</div>
						<div class="flex-row gap-2 mt-2" style="flex-wrap: wrap;" *ngIf="message.attachments?.length">
							<div class="flex-row border ellipsis p-0 cursor-pointer hvr-opacity" style="font-size: 11px; align-self: flex-start; max-width: 800px;"
								 *ngFor="let file of message.attachments"
								 (click)="openMessageAttachment(file.name, file.attachment_url)">
								<div class="flex-row gap-2 p-1 ellipsis">
									<img [src]="file.thumb_url || gs.getFileIcon(file.name)" style="height: 30px; width: 30px;"/>
									<div class="flex-column ellipsis gap-1">
										<span class="ellipsis">{{file.name}}</span>
										<span class="text-muted">{{file.size | FormatBytes:0}}</span>
									</div>
								</div>
							</div>
						</div>
						<hr class="opacity-50" *ngIf="!last"/>
					</div>
				</div>
			</div>
		</div>
	</popup-c>

	<popup-c *ngIf="closeTicketPopup?.show" class="overflownV"
			 [head]="closeTicketPopup.title" size="dynamic"
			 (closeCb)="closeTicketPopup = null;" (confirmCb)="closeTicketPopup.doneCb()"
			 [buttons]="{confirm: {text: 'Confirm', loading: closeTicketPopup.inProcess, disabled: !closeTicketPopup.satisfaction}, cancel: 'Cancel'}">
        <div class="flxClmn f-1-0 vSpace1" style="position: relative; min-height: 200px;">
			<span style="font-size: 14px; font-weight: bold;">Satisfaction Rating</span>
			<span>How would you rate your overall satisfaction for the resolution provided by the agent?</span>
			<div class="flex-row gap-3 mt-2">
				<div class="border border-2 rounded-1 p-2" style="cursor: pointer;" (click)="closeTicketPopup.satisfaction = 103" [ngClass]="{'border-success': closeTicketPopup.satisfaction === 103}">
					<i class="far fa-smile text-success" tooltip="Happy" style="font-size: 1.4rem; border-radius: 50%; background-color: white;"></i>
				</div>
				<div class="border border-2 rounded-1 p-2" style="cursor: pointer;" (click)="closeTicketPopup.satisfaction = 100" [ngClass]="{'border-warning': closeTicketPopup.satisfaction === 100}">
					<i class="far fa-meh text-warning" tooltip="Neutral" style="font-size: 1.4rem; border-radius: 50%; background-color: white;"></i>
				</div>
				<div class="border border-2 rounded-1 p-2" style="cursor: pointer;" (click)="closeTicketPopup.satisfaction = -103" [ngClass]="{'border-danger': closeTicketPopup.satisfaction === -103}">
					<i class="far fa-frown text-danger" tooltip="Unhappy" style="font-size: 1.4rem; border-radius: 50%; background-color: white;"></i>
				</div>
			</div>
			<span class="mt-3">Would you like to share any other comments?</span>
			<textarea style="width: 100%; max-height: 100px;"
					  maxlength="400"
					  placeholder="Your feedback here (optional)"
					  [(ngModel)]="closeTicketPopup.feedback"></textarea>
        </div>
    </popup-c>

</div>
